import { useEffect, useCallback } from 'react'
import cacheManager from '@/lib/cache-management'

/**
 * 缓存管理Hook
 * 在应用启动时自动检查版本更新
 */
export function useCacheManagement() {
  // 检查更新
  const checkForUpdates = useCallback(async () => {
    try {
      const hasUpdate = await cacheManager.checkForUpdates()
      return hasUpdate
    } catch (error) {
      console.error('检查更新失败:', error)
      return false
    }
  }, [])

  // 强制刷新
  const forceRefresh = useCallback(() => {
    cacheManager.forceRefresh()
  }, [])

  // 获取构建信息
  const getBuildInfo = useCallback(() => {
    return cacheManager.getBuildInfo()
  }, [])

  // 应用启动时自动检查
  useEffect(() => {
    // 延迟5秒后检查更新，避免影响初始加载性能
    const timer = setTimeout(() => {
      checkForUpdates()
    }, 5000)

    return () => clearTimeout(timer)
  }, [checkForUpdates])

  // 定期检查更新（每30分钟）
  useEffect(() => {
    const interval = setInterval(() => {
      checkForUpdates()
    }, 30 * 60 * 1000) // 30分钟

    return () => clearInterval(interval)
  }, [checkForUpdates])

  return {
    checkForUpdates,
    forceRefresh,
    getBuildInfo
  }
}